import {app} from '../app';
import IPromise = angular.IPromise;
import {ISessionService} from "./SessionService";
import moment = require("moment/moment");

export enum LoggerKey {
    FullScreen,
    Language,
    Session,
    Timeout,
    CurrentQuestion,
    AnsweredTooFast,
    Impersonated
}

export class LoggerService {

    private http:ng.IHttpService;
    private q:ng.IQService;
    private sessionService:ISessionService;

    constructor($http:ng.IHttpService, $q:ng.IQService, SessionService:ISessionService) {
        this.http = $http;
        this.q = $q;
        this.sessionService = SessionService;
    }

    log(key: LoggerKey, value: any):ng.IPromise<any> {
        if (!this.sessionService.activeSession) {
            return this.q.reject();
        }

        return this.http.post(
            '/api/session/' + this.sessionService.activeSession.id + '/log',
            JSON.stringify({
                fired_at: moment().utc(),
                key: LoggerKey[key].replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(),
                value: value
            })
        ).then((data) => {
            return this.q.resolve(data);
        }, (data) => this.q.reject(data));
    }

    static factory() {
        const factory = ($http:ng.IHttpService, $q:ng.IQService, SessionService:ISessionService) => new LoggerService($http, $q, SessionService);
        factory.$inject = ['$http', '$q', 'SessionService'];
        return factory;
    }
}

app.factory('LoggerService', LoggerService.factory());